import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService, StorageService } from 'src/services';
import { UserInfo } from 'src/models';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

  private userInfoSubject = new BehaviorSubject<UserInfo | null>(null);
  userInfo$ = this.userInfoSubject.asObservable();

  constructor(
    private apiService: ApiService,
    private storage: StorageService
  ) {}

  async fetchAndSetUserInfo(): Promise<boolean> {
    const token = this.storage.getItem("token");
    if (!token) {
      this.clearUserInfo();
      return false;
    }

    const res = await this.apiService["getUserInfo"]();
    if (res.status !== 'success') {
      this.clearUserInfo();
      console.log("not login");
      return false;
    }

    console.log("user info", res.result);
    this.userInfoSubject.next(res.result);
    return true;
  }

  getUserInfo(): UserInfo | null {
    return this.userInfoSubject.getValue();
  }

  clearUserInfo(): void {
    this.userInfoSubject.next(null);
  }
}
